import { render, staticRenderFns } from "./ReportIncidentFormExternal.vue?vue&type=template&id=47fdaef4&scoped=true"
import script from "./ReportIncidentFormExternal.vue?vue&type=script&lang=js"
export * from "./ReportIncidentFormExternal.vue?vue&type=script&lang=js"
import style0 from "./ReportIncidentFormExternal.vue?vue&type=style&index=0&id=47fdaef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fdaef4",
  null
  
)

export default component.exports